import "@/App.css";
import api from "@/lib/api";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/common/WhatsAppButton";

import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Directory from "@/pages/Directory";
import OrganPage from "@/pages/OrganPage";
import StatePage from "@/pages/StatePage";
import HospitalPage from "@/pages/HospitalPage";
import StoryPage from "@/pages/StoryPage";
import ShareFlow from "@/pages/share/ShareFlow";
import { IntroStep, AboutStep, WhereStep, DetailsStep, ThanksStep } from "@/pages/share/steps";
import StoryStep from "@/pages/share/StoryStep";
import SearchPage from "@/pages/SearchPage";
import About from "@/pages/About";
import Feedback from "@/pages/Feedback";
import Knowledge from "@/pages/Knowledge";
import ArticlePage from "@/pages/ArticlePage";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/share");
  return (
    <>
      <Nav />
      <main className="flex-1">{children}</main>
      {!bare && <Footer />}
      {!bare && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/explore" element={<Shell><Explore /></Shell>} />
            <Route path="/centres" element={<Shell><Directory /></Shell>} />
            <Route path="/organ/:slug" element={<Shell><OrganPage /></Shell>} />
            <Route path="/state/:code" element={<Shell><StatePage /></Shell>} />
            <Route path="/hospital/:slug" element={<Shell><HospitalPage /></Shell>} />
            <Route path="/story/:id" element={<Shell><StoryPage /></Shell>} />
            <Route path="/share" element={<Shell><ShareFlow /></Shell>}>
              <Route index element={<IntroStep />} />
              <Route path="about" element={<AboutStep />} />
              <Route path="where" element={<WhereStep />} />
              <Route path="details" element={<DetailsStep />} />
              <Route path="story" element={<StoryStep />} />
              <Route path="thanks" element={<ThanksStep />} />
            </Route>
            <Route path="/search" element={<Shell><SearchPage /></Shell>} />
            <Route path="/about" element={<Shell><About /></Shell>} />
            <Route path="/feedback" element={<Shell><Feedback /></Shell>} />
            <Route path="/knowledge" element={<Shell><Knowledge /></Shell>} />
            <Route path="/knowledge/:slug" element={<Shell><ArticlePage /></Shell>} />
            <Route path="/privacy" element={<Shell><Legal kind="privacy" /></Shell>} />
            <Route path="/terms" element={<Shell><Legal kind="terms" /></Shell>} />
            <Route path="/guidelines" element={<Shell><Legal kind="guidelines" /></Shell>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <TrackVisit />
        </BrowserRouter>
        <Toaster position="bottom-center" />
      </AuthProvider>
    </div>
  );
}

function TrackVisit() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (sessionStorage.getItem("ts_visited")) return;
    sessionStorage.setItem("ts_visited", "1");
    api.post("/track/visit").catch(() => {});
  }, [pathname]);
  return null;
}

export default App;
